<div class="upsell-guarantee p-4">
  <div class="upsell-guarantee__container max-w-container mx-auto flex flex-col-reverse desktop:flex-row items-center gap-8">
    <div class="upsell-guarantee__content w-full desktop:basis-3/5">
      @if (guaranteeCopy) {
        <div class="upsell-guarantee__copy mb-4" [innerHTML]="guaranteeCopy"></div>
      }
      <div class="upsell-guarantee__buttons flex flex-col gap-4">
        <button
          data-qa="cta-yes"
          class="upsell-guarantee__button-yes bg-dmp-gold hover:bg-dmp-gold-dark w-full text-center font-extrabold uppercase text-white text-lg leading-6 p-4 rounded-sm active:translate-y-0.5"
          (click)="nextPage(true)"
          data-te="cta-yes"
          [innerHTML]="buttonYesText">
        </button>
        <button
          data-qa="cta-no"
          class="upsell-guarantee__button-no bg-dmp-gray w-full text-center uppercase text-white p-4 rounded-sm active:translate-y-0.5"
          (click)="nextPage(false)"
          [innerHTML]="buttonNoText"
          data-te="cta-no">
        </button>
      </div>
    </div>
    @if (guaranteeImage) {
      <img class="upsell-guarantee__image w-3/4 desktop:w-auto desktop:basis-2/5 desktop:min-w-0" [src]="guaranteeImage" alt="">
    }
  </div>
</div>
